export const handleRedirectIfDeslogged = async (url) => {
  localStorage.setItem('@BPOOL-redirect-url-after-login', url);
};

export const getRedirectIfDeslogged = async () => {
  return localStorage.getItem('@BPOOL-redirect-url-after-login');
};